import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
/**
 * Txp options settings
 */
let TxpOption: LazyOption = createLazyOption(
    {
        key: 'txp',
        titleStringKey: 'optionTitle_eventsForEmail',
        searchTermsStringKey: 'optionSearch_eventsForEmail',
        hideTitleInFullOptions: true,
        isHidden: () => IsShadowMailboxUser(),
        allowedOptionKeys: ['EventsFromEmail'],
    },
    lazyFullModule,
    m => m.default
);
export default TxpOption;
